<template>
  <a-card>
    <div v-if="deployPermission || ticketId" class="deploy-action">
      <a-space size="small">
        <a-button v-if="deployPermission && !canUseGrayDeploy" v-tc="{ name: '一键部署' }" class="deploy-action_button" type="primary" @click="onDeploy('common')"> 一键部署 </a-button>
        <a-button v-if="processingServices.length > 0" v-tc="{ name: '发布队列' }" type="primary" @click="onReleaseTaskQueues"> 发布队列 </a-button>
        <template v-if="deployPermission && canUseGrayDeploy">
          <a-button v-if="false && dataSource[0].status != 6" v-tc="{ name: '灰度部署' }" class="deploy-action_button" type="primary" @click="onDeploy('gray')"> 灰度部署 </a-button>
          <a-button v-if="checkStatusSeven(7)" v-tc="{ name: '外灰通过' }" class="deploy-action_button" type="primary" @click="onDeploy('continue')"> 外灰通过 </a-button>
          <a-button v-if="checkStatusSeven(7)" v-tc="{ name: '外灰不通过' }" class="deploy-action_button" type="primary" @click="onBack('rollback')"> 外灰不通过 </a-button>
          <a-button v-if="checkStatusSeven(6)" v-tc="{ name: '内灰通过' }" class="deploy-action_button" type="primary" @click="onContinue('continue')"> 内灰通过 </a-button>
          <a-button v-if="checkStatusSeven(6)" v-tc="{ name: '内灰不通过' }" class="deploy-action_button" type="primary" @click="onBack('rollback')"> 内灰不通过 </a-button>
        </template>
      </a-space>
      <a v-if="ticketId" v-tc="{ name: '查看日志' }" style="float: right; margin-bottom: 16px" @click="onShowConsole"> <a-icon type="code" /> 查看日志 </a>
    </div>
    <div class="deploy-alert">
      <a-alert v-if="processingServices.length > 0" :type="templateId !== 17 ? 'warning' : 'info'" show-icon banner>
        <span slot="message">
          {{ `「${processingServices.map(item => item.service_name).join(',')}」服务有早于当前镜像版本的流程未完成` }}
        </span>
      </a-alert>
      <a-alert v-if="deployEnvs.includes(4)" type="info" show-icon banner>
        <span slot="message"> Demo环境正在发布中, 请等待运维同学发布完成 </span>
      </a-alert>
    </div>
    <a-table ref="table" size="middle" :scroll="{ x: 1400 }" :pagination="false" row-key="release_service_id" :columns="columns" :data-source="dataSource">
      <span slot="expandedRowRender" slot-scope="record">
        <a-descriptions v-if="[1, 2].includes(record.service_type.value)" size="small" :column="1">
          <a-descriptions-item label="GitTag">{{ record.git_tag_name }} </a-descriptions-item>
          <a-descriptions-item label="制品地址">{{ record.image_url }} </a-descriptions-item>
          <a-descriptions-item label="关联信息">
            <span v-if="!record.issues">--</span>
            <div v-for="issue in record.issues" :key="issue.key">
              <a class="custom-link" :href="issueLink(issue)" target="_blank">{{ issue.key }} {{ issue.title }} </a>
            </div>
          </a-descriptions-item>
          <a-descriptions-item v-if="Array.isArray(record.data_change) && record.data_change.length > 0" label="数据变更">
            <a-tag v-for="key in record.data_change" :key="key" color="pink">{{ dataChangeOptionMap[key].label }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item v-if="Array.isArray(record.configs) && record.configs.length > 0" label="确认配置项">
            <a-tag v-for="(item, index) in record.configs" :key="index" color="orange">{{ item }}</a-tag>
          </a-descriptions-item>
        </a-descriptions>
        <service-deploy-record :data-source="record.records" />
      </span>
      <span slot="artifactVersion" slot-scope="text, record">
        <a-tooltip v-if="[1, 2].includes(record.service_type.value)">
          <template slot="title"> {{ record.image_url }} </template>
          <span class="artifact-ersion_value" @click="onVersionDetail(record.artifact_version_id)">{{ record.artifact_version }}</span>
        </a-tooltip>
        <span v-else-if="record.artifact_version_id !== null"> {{ record.build_version }} <a-icon type="qrcode" @click="onQrCode(record)" /> </span>
        <span v-else>{{ record.image }}</span>
      </span>
      <span slot="serviceType" slot-scope="text, record"> {{ serviceTypes[record.service_type.value].label }}</span>
      <span slot="developers" slot-scope="text, record"><user-profiles :value="record.developers.map(item => item.id)" avatar /></span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="releaseDeployStatus[record.status].status" :text="releaseDeployStatus[record.status].label" />
      </span>
      <span slot="processingWorkflow" slot-scope="text, record">
        <a-popover v-if="record.processing_workflow" title="其他未完成的流程" placement="topLeft">
          <template slot="content">
            <workflow-small-list :data-source="record.processing_workflow" />
          </template>
          <a type="primary">查看流程</a>
        </a-popover>
        <span v-else>--/--</span>
      </span>
      <span slot="strategy" slot-scope="text, record">
        <a-popover v-if="record.strategy !== null">
          <template slot="content">
            <template v-for="(item, key) in record.strategy">
              <a-tag v-if="serviceStrategys[item]" :key="key" :color="serviceStrategys[item].color">{{ serviceStrategys[item].name }}</a-tag>
            </template>
          </template>
          <span>
            <template v-for="(item, key) in record.strategy">
              <a-tag v-if="serviceStrategys[item]" :key="key" :color="serviceStrategys[item].color">{{ serviceStrategys[item].name }}</a-tag>
            </template>
          </span>
        </a-popover>
      </span>
      <span slot="release" slot-scope="text, record">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ record.release_title }}</span>
          </template>
          <a class="custom-link" @click="onDetail(record)"> {{ record.release_title }} </a>
        </a-tooltip>
      </span>
    </a-table>
    <qr-code-modal :is-show="qrCodeDisplay" :content="qrCodeData" @close="close" />
    <a-modal v-model="visible" title="选择部署环境" :confirm-loading="loading" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="部署环境" prop="environment">
          <a-radio-group v-model="form.environment">
            <a-radio v-for="(env, index) in deployEnvs" :key="index" :value="env">{{ releaseEnvs[env] ? releaseEnvs[env].label : '--' }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="visibleBack" title="灰度不通过" :confirm-loading="loading" @ok="onSubmit">
      {{ '确认后会撤回灰度服务，请注意' }}
    </a-modal>
    <a-modal v-model="visibleContinue" title="内灰通过" :confirm-loading="loading" @ok="onSubmit">
      {{ '确认后会继续进行外灰发布，请注意' }}
    </a-modal>
    <service-deploy-console :ticket-id="ticketId" :visible="consoleVisible" @close="close" />
    <artifact-version-drawer ref="artifactVersionDrawerRef" />
    <workflow-release-task-queue ref="workflowReleaseTaskQueueRef" />
  </a-card>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { workflowDeploy } from '@/api/project/workflow';
import { serviceTypes, releaseDeployStatus, dataChangeOptions, releaseEnvs } from '@/utils/dictionary';

import QrCodeModal from '@/pages/tools/application/components/QrCodeModal';
import WorkflowSmallList from '@/pages/project/workflow/components/WorkflowSmallList';
import ArtifactVersionDrawer from '@/pages/project/service/components/ArtifactVersionDrawer';
import ServiceDeployRecord from '@/pages/project/workflow/release/components/ServiceDeployRecord';
import ServiceDeployConsole from '@/pages/project/workflow/release/components/ServiceDeployConsole';
import WorkflowReleaseTaskQueue from '@/pages/project/workflow/components/WorkflowReleaseTaskQueue';

const columns = [
  {
    title: 'ID',
    width: 80,
    dataIndex: 'release_service_id'
  },
  {
    title: '类型',
    dataIndex: 'type',
    width: 80,
    scopedSlots: { customRender: 'serviceType' }
  },
  {
    title: '服务',
    ellipsis: true,
    dataIndex: 'service_name'
  },
  {
    title: '制品版本',
    width: 160,
    ellipsis: true,
    dataIndex: 'artifact_version',
    scopedSlots: { customRender: 'artifactVersion' }
  },
  {
    title: '服务状态',
    width: 100,
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '其他未完成的流程',
    width: 160,
    ellipsis: true,
    scopedSlots: { customRender: 'processingWorkflow' }
  },
  {
    title: '开发者',
    width: 100,
    ellipsis: true,
    dataIndex: 'developers',
    scopedSlots: { customRender: 'developers' }
  },
  {
    title: '发布策略',
    width: 120,
    ellipsis: true,
    dataIndex: 'strategy',
    scopedSlots: { customRender: 'strategy' }
  },
  {
    title: '发布评审',
    ellipsis: true,
    dataIndex: 'release_title',
    scopedSlots: { customRender: 'release' }
  }
];

export default {
  components: { QrCodeModal, ServiceDeployRecord, WorkflowSmallList, ServiceDeployConsole, ArtifactVersionDrawer, WorkflowReleaseTaskQueue },
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    },
    processingServices: {
      type: [Array, String],
      default: () => {
        return [];
      }
    },
    stepId: {
      type: Number,
      default: null
    },
    deployPermission: {
      type: Boolean,
      default: false
    },
    templateId: {
      type: [Number, String],
      default: null
    },
    ticketId: {
      type: String,
      default: null
    },
    deployEnvs: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      consoleVisible: false,
      visibleBack: false,
      visibleContinue: false,
      releaseEnvs,
      serviceTypes,
      serviceStrategys: {},
      dataChangeOptions,
      releaseDeployStatus,
      qrCodeDisplay: false,
      qrCodeData: {},
      form: {
        environment: null
      },
      rules: {
        environment: [{ required: true, message: '发布环境不能为空', trigger: 'blur' }]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      projectId: parseInt(this.$route.params.project_id) || null,
      workflowId: parseInt(this.$route.query.workflowId) || null
    };
  },
  computed: {
    dataChangeOptionMap() {
      return this.dataChangeOptions.reduce((results, item, _) => {
        results[item.value] = item;
        return results;
      }, {});
    },
    canUseGrayDeploy() {
      return this.dataSource.some(item => 'grayTemp' in item && item.grayTemp !== '' && this.stepId === 98);
    },
    checkStatusSeven() {
      return num => {
        return this.dataSource
          .filter(item => item.grayTemp !== '') // 过滤条件：grayTemp必须为1
          .every(filteredItem => filteredItem.status === num);
      };
    },
    issueLink() {
      return record => {
        if (record.issue_type === 'task') {
          const route = this.$router.resolve({
            name: 'page:project:task:detail',
            query: { taskId: record.id },
            params: { project_id: record.project_id }
          });
          return route.href;
        } else {
          const route = this.$router.resolve({
            name: 'page:project:quality:issue:detail',
            query: { issueId: record.id },
            params: { project_id: record.project_id }
          });
          return route.href;
        }
      };
    }
  },
  mounted() {
    this.getTagData();
  },
  methods: {
    getTagData() {
      tagList({ group_code: 'release_strategy' }).then(res => {
        const tags = {};
        res.data.items.forEach(item => {
          tags[item.name] = item;
        });
        this.serviceStrategys = tags;
      });
    },
    onDeploy(deployFlag) {
      console.log(deployFlag);
      this.visible = true;
      this.form.environment = this.deployEnvs.length > 0 ? this.deployEnvs[0] : null;
      if (deployFlag != null) {
        this.form.flag = deployFlag;
      }
    },
    onBack(deployFlag) {
      if (deployFlag != null) {
        this.form.flag = deployFlag;
        this.visibleBack = true;
      }
    },
    onContinue(deployFlag) {
      if (deployFlag != null) {
        this.form.flag = deployFlag;
        this.visibleContinue = true;
      }
    },

    onSubmit() {
      this.loading = true;
      workflowDeploy({ project_id: this.projectId, workflow_id: this.workflowId, env: this.form.environment, flag: this.form.flag })
        .then(() => {
          if (this.form.flag === 'rollback') {
            this.$message.success('灰度发布已撤回，请持续观察');
          } else {
            this.$message.success('部署任务提交成功，请耐心等待');
          }
          this.loading = false;
          this.visible = false;
          this.visibleBack = false;
          this.visibleContinue = false;
          this.$emit('callback');
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDetail(record) {
      const route = this.$router.resolve({
        name: 'page:project:workflow:release:detail',
        query: { releaseId: record.release_id }
      });
      window.open(route.href, '_blank');
    },

    onQrCode(record) {
      this.qrCodeDisplay = true;
      this.qrCodeData = {
        app_name: '中免日上',
        download_url: record.download_url,
        platform: record.service_type.value === 3 ? 'iOS' : 'Android',
        category: record.category,
        build_version: record.build_version,
        created_time: record.created_time
      };
    },

    onShowConsole() {
      this.consoleVisible = true;
    },

    onVersionDetail(versionId) {
      this.$nextTick(() => {
        this.$refs.artifactVersionDrawerRef.onOpen(versionId);
      });
    },

    onReleaseTaskQueues() {
      this.$nextTick(() => {
        this.$refs.workflowReleaseTaskQueueRef.open(this.workflowId);
      });
    },

    close() {
      this.qrCodeData = {};
      this.qrCodeDisplay = false;
      this.consoleVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.release-service {
  margin-top: 16px;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
:deep(.ant-card-body) {
  padding: 16px;
}
.deploy-action {
  height: 32px;
  line-height: 32px;
  margin-bottom: 8px;

  .deploy-action_button {
    margin-right: 16px;
  }
}
.artifact-ersion_value:hover {
  cursor: pointer;
}

:deep(.ant-descriptions-item > span) {
  display: inline-table;
}
.deploy-alert {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
</style>
